// 分发统计
import request from '@/utils/request'

// 分发统计渠道数据
export const getChannelData = (data: any) =>
  request({
    url: '/dataCenter/distribute',
    method: 'get',
    params: data
  })
